/**
 * A global namespace for `focusin` event.
 */
const focusinEvent = "focusin";
export default focusinEvent;
